module.exports = __webpack_public_path__ + "static/img/1.ceb1764.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/sp/1.png
// module id = LfDh
// module chunks = 0